import BaseInputField from "../../../../components/elements/BaseInputField"
import BaseDivider from "../../../../components/elements/BaseDivider"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import BaseInputSelection from "../../../../components/elements/BaseInputSelection"
import { ReactComponent as DeleteIcon } from "../../../../assets/DeleteICON.svg"
import { ReactComponent as CloseIcon } from "../../../../assets/CloseICON.svg"
import { ReactComponent as ApproveIcon } from "../../../../assets/ApprovaICON.svg"
import { Form, FormInstance } from "antd"
import { CustomerType } from "../../types/Types"
import { useEffect } from "react"

type AddCustomerModalScreenType = {
    form: FormInstance
    customer: CustomerType
    setCustomer: (e: CustomerType | undefined) => void
    adminList?: any[] // TODO
    choosenAdmin?: any
    setchoosenAdmin?: (e: any) => void
    inputAdmin?: boolean
    setinputAdmin?: () => void
    deleteAdmin?: () => void
    deleteAdminScreen?: boolean
    setdeleteAdminScreen?: () => void
    inputType: "customer" | "administrator"
}

export default function AddCustomerModalScreen1(props: AddCustomerModalScreenType) {
    const handleButton = () => {
        if (props.setchoosenAdmin && props.setinputAdmin) {
            props.setchoosenAdmin("")
            props.setinputAdmin()
        }
    }

    useEffect(() => {
        props.form.setFieldsValue({
            ["name" + props.inputType]: props.customer?.name ?? undefined,
            ["tel" + props.inputType]: props.customer?.tel ?? undefined,
            ["mail" + props.inputType]: props.customer?.mail ?? undefined,
            ["person" + props.inputType]: props.customer?.person ?? undefined,
            ["comment" + props.inputType]: props.customer?.comment ?? undefined,
            ["street" + props.inputType]: props.customer?.adress?.street ?? undefined,
            ["nr" + props.inputType]: props.customer?.adress?.nr ?? undefined,
            ["plz" + props.inputType]: props.customer?.adress?.plz ?? undefined,
            ["city" + props.inputType]: props.customer?.adress?.city ?? undefined,
        })
    }, [props.customer])

    return (
        <>
            {/* Basically Screen 2 */}
            {props.adminList && (
                <div className="flex flex-col items-center justify-center pt-4 gap-4">
                    {!props.inputAdmin && props.setchoosenAdmin && (
                        <Form form={props.form} className="!w-full">
                            <Form.Item name={"choosenAdmin" + props.inputType} className="!mb-2 !w-full" rules={[{ required: true, message: "Bitte wählen Sie einen Verwalter aus" }]}>
                                <BaseInputSelection
                                    label={"Bestehenden Verwalter auswählen"}
                                    placeholder={"Bitte Auswählen..."}
                                    data={props.adminList}
                                    setId={(e) => {
                                        props.setchoosenAdmin?.(e)
                                        props.form.setFieldsValue({ ["choosenAdmin" + props.inputType]: e })
                                    }}
                                />
                            </Form.Item>
                        </Form>
                    )}
                    <div className="flex w-full justify-between">
                        {!props.inputAdmin && (
                            <div className="flex items-center max-w-md">
                                <button
                                    className={`btn btn-square ${props.deleteAdminScreen ? "btn-error" : "btn-primary btn-outline"}`}
                                    onClick={props.setdeleteAdminScreen}
                                    disabled={!props.choosenAdmin}>
                                    {!props.deleteAdminScreen ? <DeleteIcon className="w-6 h-6" /> : <CloseIcon className="w-6 h-6" />}
                                </button>
                                {props.deleteAdminScreen && (
                                    <>
                                        <p className="text-error text-sm px-4 w-fit">Wollen Sie den Verwalter wirklich löschen? Er wird danach nicht mehr zur Auswahl stehen.</p>
                                        <button className="btn btn-square btn-primary" onClick={props.deleteAdmin}>
                                            <ApproveIcon className="w-6 h-6" />
                                        </button>
                                    </>
                                )}
                            </div>
                        )}
                        {!props.deleteAdminScreen && (
                            <button className="btn btn-primary " onClick={handleButton}>
                                {!props.inputAdmin ? "Neuen Verwalter-Datensatz hinzufügen" : "Bestehenden Verwalter auswählen"}
                            </button>
                        )}
                    </div>
                </div>
            )}
            {/* Screen 1 */}
            {(props.inputAdmin || !props.adminList) && !props.deleteAdminScreen && (
                <>
                    <Form form={props.form}>
                        <div className="flex flex-row gap-4 pt-2">
                            <Form.Item className="mb-2 w-full" name={"name" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie einen Namen ein" }]}>
                                <BaseInputField label={"Name"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, name: e })} />
                            </Form.Item>
                            <Form.Item className="mb-2 w-80" name={"tel" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie eine Telefonnummer ein" }]}>
                                <BaseInputField label={"Telefonnummer"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, tel: e })} />
                            </Form.Item>
                        </div>
                        <BaseInputField classProps="mb-2" label={"Ansprechpartner (optional)"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, person: e })} />
                        <Form.Item className="mb-2 w-full" name={"mail" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie eine E-Mail-Adresse ein" }]}>
                            <BaseInputField label={"E-Mail-Adresse"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, mail: e })} />
                        </Form.Item>
                        <BaseInputArea label={"Bemerkung"} onChange={(e) => props.setCustomer({ ...props.customer, comment: e })} required={false} />
                        <BaseDivider classProps="mb-4 mt-6" />
                        <div className="flex flex-row gap-4">
                            <Form.Item className="mb-2 w-full" name={"street" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie eine Straße ein" }]}>
                                <BaseInputField label={"Straße"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, adress: { ...props.customer.adress, street: e } })} />
                            </Form.Item>
                            <Form.Item className="mb-2 w-48" name={"nr" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie eine Hausnummer ein" }]}>
                                <BaseInputField label={"Hausnummer"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, adress: { ...props.customer.adress, nr: e } })} />
                            </Form.Item>
                        </div>
                        <div className="flex flex-row gap-4 pb-4">
                            <Form.Item className="mb-2 w-64" name={"plz" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie eine PLZ ein" }]}>
                                <BaseInputField label={"PLZ"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, adress: { ...props.customer.adress, plz: e } })} />
                            </Form.Item>
                            <Form.Item className="mb-2 w-3/4" name={"city" + props.inputType} rules={[{ required: true, message: "Bitte geben Sie eine Stadt ein" }]}>
                                <BaseInputField prevent label={"Stadt"} type={"text"} onChange={(e) => props.setCustomer({ ...props.customer, adress: { ...props.customer.adress, city: e } })} />
                            </Form.Item>
                        </div>
                    </Form>
                </>
            )}
        </>
    )
}
